import { call, put, select, takeLatest } from "redux-saga/effects";
import flowStages from "../../flowStages";
import actiontypes from "../actions/actiontypes";
import {
    emailAutoLinkWatcher,
    handleError,
    loginSetFlowStageWatcher,
    setFetching,
} from "../actions/loginactioncreators";
import { navigateToAuthorize } from "../helpers/navigators";

export function* handleExitReadinessCheck(action) {
    try {
        const autoLinkStatus = yield select(state => state.loginForm.emailAutoLinkData?.status );
        const autoLinkNonFederatedByEmail = yield select(state => state.loginForm.autoLinkNonFederatedByEmail);

        yield put(setFetching(true));
        
        if (autoLinkStatus === "needed" && autoLinkNonFederatedByEmail) {
            yield put(loginSetFlowStageWatcher({ flowStage: flowStages.EMAIL_AUTO_LINK }));
            yield put(emailAutoLinkWatcher());
            return;
        }

        if (action.payload?.callback) {
            return yield call(action.payload.callback);
        }
        if (action.payload?.put) {
            return yield put(action.payload.put);
        }
        navigateToAuthorize();
    } catch (error) {
        yield put(handleError(error));
    }
}

export function* watchHandleExitReadinessCheck() {
    yield takeLatest(actiontypes.REQUEST_EXIT_READINESS_CHECK, handleExitReadinessCheck);
}
